module.exports = __webpack_public_path__ + "img/feld.d710fa15.jpg";